import React from "react";
import { useContent } from "../../hooks/useContent";

const Footer = () => {
  const { content, loading } = useContent("footer");
  
  const year = content?.year || new Date().getFullYear();
  const companyName = content?.company_name || "XLUMA.IN";
  const socialLinks = content?.social_links && Array.isArray(content.social_links) 
    ? content.social_links 
    : [
        { name: "Instagram", url: "#" },
        { name: "Twitter", url: "#" },
        { name: "LinkedIn", url: "#" }
      ];

  return (
    <footer className="bg-black pb-12 px-4 md:px-12">
      <div className="border-t border-white/10 pt-12 flex flex-col md:flex-row justify-between items-center text-gray-500 font-mono text-xs uppercase tracking-widest">
        <p>&copy; {year} {companyName}</p>
        <div className="flex gap-8 mt-4 md:mt-0">
          {socialLinks.map((link, index) => (
            <a 
              key={`social-${index}`}
              href={link.url || "#"} 
              target={link.url && link.url !== "#" ? "_blank" : undefined}
              rel={link.url && link.url !== "#" ? "noopener noreferrer" : undefined}
              className="hover:text-white transition-colors hover-trigger"
            >
              {link.name || "Link"}
            </a>
          ))}
        </div>
      </div>
      
      <h1 className="text-[15vw] leading-none font-display font-bold text-center text-white/5 mt-12 select-none">
        XLUMA
      </h1>
    </footer>
  );
};

export default Footer;
